// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NftCard-image{width:100%}.NftCard-thumbnail{cursor:pointer}", "",{"version":3,"sources":["webpack://./src/client/css/NftCard.scss"],"names":[],"mappings":"AAAA,eACE,UAAA,CAGF,mBACE,cAAA","sourcesContent":[".NftCard-image {\n  width: 100%;\n}\n\n.NftCard-thumbnail {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
